import type { FaireProductEntity } from "../../entity_types/product";

export const p_rrjkth3rh3: FaireProductEntity = {
  token: "p_rrjkth3rh3",
  type: "product",
  name: "Bee Clean Organic Beeswax Hand Sanitizer-13 Citrus 4 packs",
  brandToken: "b_zkxn3dn2pw",
  brandName: "Bee Clean",
  imageUrl:
    "https://cdn.faire.com/fastly/201d8a667ab82141ed9b37b1d4492abda425101e00c7b08c2c996c7efd2c12de.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/731d56bb4d981fae0696b434b26e73de0638b64535f520be62c4459ac946f414.jpeg",
    "https://cdn.faire.com/fastly/e1a840f5d973d526dd0535bb2c2f09dba61d3869ea5f57f6d84704fb7a2b5c7f.jpeg",
    "https://cdn.faire.com/fastly/fa2b9ae5318edfbf297e7f97fc58f0c4bb26e6328f6af463067661c889821abf.jpeg",
    "https://cdn.faire.com/fastly/b8f950fc3781b75cec02d894ed0b36c2b9363478be992293ea352cb2117b62ee.jpeg",
    "https://cdn.faire.com/fastly/3c5aa2a1fd28bcadfdd34cbddf0b76a554796edb04a40856c5e4ac4cb955a377.jpeg",
    "https://cdn.faire.com/fastly/7a6db7c4ffb0148ae4fcbfc601cf515ab3338e4c660193865a4793e62f235f57.jpeg",
    "https://cdn.faire.com/fastly/2258c433e77f34ca4aa71c20acbde36e5a803a0e8358f2e0d27e4041c42aa46c.jpeg",
    "https://cdn.faire.com/fastly/d9214e0214fa8229ec48b9ee02a7579752332b50cc731f8bb39d185ca6282393.jpeg",
    "https://cdn.faire.com/fastly/02c311e0a519da1c0a7fb8c988a08aae61a989bc2c5ba3b409ec2d2d506df68b.jpeg",
    "https://cdn.faire.com/fastly/8f1eeeae76f20c3dd1e5daf8b022cb085aea66a49c3bd813df8c84a0c8080c50.jpeg",
    "https://cdn.faire.com/fastly/2f61abb55e9e30761266c4ea494aa3a7aa1a4270e842c2e4ea7a5ebf458e1f4c.jpeg",
    "https://cdn.faire.com/fastly/c3e87886d1508cac08f2914028b3656b2f919c28fd71a4c4db8feb6d62b816a3.jpeg",
    "https://cdn.faire.com/fastly/aee31df51085f9e6ba0bc0c0d1057a1113cb72d2c114bf5a7b54fdcac0da9e43.jpeg",
    "https://cdn.faire.com/fastly/4f00aad617c62e4c1b63ff83f2e4cb42aed2d02d4b0c7f78f89a889164046187.png",
    "https://cdn.faire.com/fastly/a9893477489b6a1ad8df4dae8a7b17256e9db44b111fd416f04914e8256f291c.jpeg",
    "https://cdn.faire.com/fastly/55df81be03f2cf8597dff186c13a106d8b75073a707420d6ab7abb6a7956fadc.png",
    "https://cdn.faire.com/fastly/ec65ab040dd626edf93f544c7a38f3d464ce9a52ad194d381f62ae249c6f6a9b.jpeg",
    "https://cdn.faire.com/fastly/7751806978d4cab2658e8a4b74b6cdb5919044e1dc24d3408ac4b60a4cb45615.png",
    "https://cdn.faire.com/fastly/70728b86ee5e9ceaa5da878a87ac555965e9b4d735271a9caedb9b0d0fd95efe.jpeg",
  ],
  priceDollars: 15.24,
  description:
    "Bee Clean Beeswax Hand Sanitizers help you stay healthy and humming by killing germs with kinder, 100% organic and natural ingredients. Our spray-on mist is mess free via our convenient, innovative, recyclable packaging. Bee Clean contains natural antimicrobial peptides and organic ethyl alcohol to kill 99.9% of germs. It moisturizes using beeswax, vitamin E, avocado oil and apricot seed oil so hands feel soft and dry with no sticky residue. Our refreshing citrus peppermint and lavender essential scents are light and revitalizing. Bee Clean is proudly made in the USA and a NM True Certified product. These 13 citrus & peppermint scent 4 packs are a great impulse item to place at your cash register (for a total of 52 citrus units).",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:53.501Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
